module.exports = __webpack_public_path__ + "static/media/vigold.6d3c074d.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/chile/climasense/cenicilla_pimiento/curativa/vigold.png
// module id = 1441
// module chunks = 3